import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ReviewPage from "./pages/ReviewPage.jsx";
import CompaniesListPage from "./pages/CompaniesListPage.jsx";
import WidgetDemoPage from "./pages/WidgetDemoPage.jsx";
import AdminLoginPage from "./pages/AdminLoginPage.jsx";
import AdminDashboardPage from "./pages/AdminDashboardPage.jsx";
import AdminReviewsPage from "./pages/AdminReviewsPage.jsx";

// Fonction pour masquer le badge Emergent de manière agressive
const hideEmergentBadge = () => {
  // Supprimer par ID
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.remove();
  }
  
  // Supprimer tous les liens Emergent
  document.querySelectorAll('a[href*="emergent.sh"], a[href*="utm_source=emergent"]').forEach(el => {
    el.remove();
  });
};

function App() {
  useEffect(() => {
    // Exécuter immédiatement
    hideEmergentBadge();
    
    // Observer les mutations du DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.id === 'emergent-badge' || 
                (node.tagName === 'A' && node.href && node.href.includes('emergent.sh'))) {
              node.remove();
            }
          }
        });
      });
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
    
    // Backup interval
    const interval = setInterval(hideEmergentBadge, 100);
    
    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CompaniesListPage />} />
          <Route path="/review/:domain" element={<ReviewPage />} />
          <Route path="/widgets" element={<WidgetDemoPage />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/reviews/:domain" element={<AdminReviewsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
